import { render, staticRenderFns } from "./BaseImage.vue?vue&type=template&id=dbb2ef60"
import script from "./BaseImage.vue?vue&type=script&lang=js"
export * from "./BaseImage.vue?vue&type=script&lang=js"
import style0 from "./BaseImage.vue?vue&type=style&index=0&id=dbb2ef60&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports